<template>
  <section>
    <router-view/>
  </section>
</template>

<script>
import saleManagement from 'store/saleManagement.store';
import user from 'store/user.store';
import saleLog from 'store/saleLog.store';
import view from 'store/view.store';
import brand from 'store/brand.store';
import gadget from 'store/gadget.store';

const SALE_MANAGEMENT_STORE = 'saleManagement';
const USER_STORE = 'user';
const SALE_LOG_STORE = 'saleLog';
const VIEW = 'view';
const BRAND = 'brand';
const GADGET = 'gadget';

export default {
  beforeCreate() {
    this.$store.registerModule(SALE_MANAGEMENT_STORE, saleManagement);
    this.$store.registerModule(USER_STORE, user);
    this.$store.registerModule(SALE_LOG_STORE, saleLog);
    this.$store.registerModule(VIEW, view);
    this.$store.registerModule(BRAND, brand);
    this.$store.registerModule(GADGET, gadget);
  },
  beforeDestroy() {
    this.$store.unregisterModule(SALE_MANAGEMENT_STORE);
    this.$store.unregisterModule(USER_STORE);
    this.$store.unregisterModule(SALE_LOG_STORE);
    this.$store.unregisterModule(VIEW);
    this.$store.unregisterModule(GADGET);
    this.$store.unregisterModule(BRAND);
  }
};

</script>

<style lang="scss" src="theme/pages/_sales.scss"></style>
